import React from 'react';
import { useSpc } from '../context/SpcContext';

export default function Toast() {
  const { toastMsg } = useSpc();
  return <div className={`toast ${toastMsg ? 'show' : ''}`} data-testid="toast">{toastMsg}</div>;
}
